import { tryCatch } from "@/lib/try-catch";
import { Ok, Err } from "ts-results";
import { API_BASE_URL } from "@/lib/constants";
import { Response } from "./types";

export interface Report {
  id: string;
  projectId?: string | null;
  optionalId?: string | null;
  generatedAt: string;
  agent: string;
  shareCount: number;
  inputPath?: string;
  optionsPathJson?: string;
  outputPathPdf?: string;
}

export async function getAllReports(): Promise<Response<Report[]>> {
  const responseResult = await tryCatch(
    fetch(`${API_BASE_URL}/api/v1/reportes`, {
      method: "GET",
      credentials: "include",
    })
  );

  if (responseResult.err) {
    return Err({
      message: `Error al consultar el servidor: ${responseResult.val.message}`,
      devMessage: responseResult.val.message,
    });
  }

  const response = responseResult.val;

  if (!response.ok) {
    const errorMessageResult = await tryCatch(response.json());
    return errorMessageResult.err
      ? Err({
          message: `Error al obtener todos los reportes del usuario: ${errorMessageResult.val.message}`,
          devMessage: errorMessageResult.val.message,
        })
      : Err({
          message: errorMessageResult.val.message,
          devMessage: errorMessageResult.val.devMessage,
        });
  }

  const dataResult = await tryCatch(response.json());

  if (dataResult.err) {
    return Err({
      message: `Error al leer la respuesta del servidor: ${dataResult.val.message}`,
      devMessage: dataResult.val.message,
    });
  }

  return Ok(dataResult.val);
}
